export const hotelActionTypes = {
  API_RESPONSE_SUCCESS: 'API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: 'API_RESPONSE_ERROR',
  INSERT_HOTEL: 'INSERT_HOTEL',
  UPDATE_HOTEL: 'UPDATE_HOTEL',
  GET_HOTEL: 'GET_HOTEL',
  DELETE_HOTEL_DATA: 'DELETE_HOTEL_DATA'
};

export interface Hotel {
  hotel_id: number;
  owner_user_id: number;
  hotel_name: string;
  legal_name: string | null;
  short_code: string | null;
  phone: string;
  email: string;
  website: string | null;
  address_line1: string;
  address_line2: string | null;
  city: string;
  state: string;
  country: string;
  postal_code: string;
  latitude: number | null;
  longitude: number | null;
  timezone: string;
  currency_code: string;
  check_in_time: string; // '14:00'
  check_out_time: string; // '12:00'
  gstin: string | null;
  payment_method: string | null;
  logo_path: string | null;
  authorized_signatory_path: string | null;
  is_active: boolean;
  created_at: string | Date;  // ISO string or Date
  updated_at: string | Date;  // ISO string or Date
}

export interface Rooms {
  room_id: number,
  room_number: string,
  hotel_id: number,
  room_type: string,
  max_pax: number,
  is_active: boolean

}


export interface hotelReducerState {
  hotel: Hotel;
  rooms: Rooms[] | null;
  // available_rooms: any[];
  loading: boolean;
  error: string | null;
}
